<template>
  <div>
    <v-select
      :label="i18n.global.t('app.system.info.name')"
      :items="systemStore.systems"
      returnObject
      v-model="systemStore.selectedSystem"
      :disabled="isDisabled"
      validate-on="input lazy"
      :loading="systemStore.loadingState === 'loading'"
      :error-messages="
        systemStore.loadingState === 'failed'
          ? i18n.global.t('app.system.loadingData.error')
          : undefined
      "
      @update:modelValue="
        () => {
          // un-focus element (for whatever reason vuetify doesn't do this on its own in this version)
          blurFunction ? blurFunction() : '';
        }
      "
    >
      <template #message="{ message }">
        <p class="!whitespace-nowrap line-clamp-1 overflow-ellipsis">
          {{ message }}
        </p>
      </template>
      <template #selection="{ item }">
        {{ item.raw.supplierId }} ({{ item.raw.system }})
      </template>
      <template #item="{ item, props }">
        <v-list-item
          v-bind="props"
          :title="item.raw.supplierId"
          :subtitle="item.raw.system || 'test'"
        ></v-list-item>
      </template>

      <template #append>
        <v-btn
          @click="systemStore.getSystems()"
          color="primary"
          v-if="
            systemStore.loadingState === 'failed' ||
            (systemStore.loadingState === 'success' &&
              systemStore.systems.length === 0)
          "
          icon="mdi-refresh"
        ></v-btn>
      </template>
    </v-select>
  </div>
</template>

<script setup lang="ts">
// modules
import { computed, ref } from "vue";
// helpers
import { i18n } from "@/locales";
// instances
import { useSystemStore } from "@/store";

// get instances
const systemStore = useSystemStore();

// input element reference
const blurFunction = ref<() => void | undefined>();

// prevent user input when there are no systems to choose from
const isDisabled = computed(() => {
  if (systemStore.loadingState === "loading") return true;
  if (systemStore.loadingState === "unset") return true;

  return false;
});
</script>
